import React from "react";
import NumberFormat from "react-number-format";

export const TotalAmountColumnFormatter = (cellContent, row, rowIndex) => {
  const { totalAmount = 0 } = row || {};

  const amountFormatter = () => {
    return (
      <NumberFormat
        value={totalAmount ? totalAmount : 0}
        displayType="text"
        thousandSeparator={true}
        prefix="$"
        decimalSeparator="."
        decimalScale={2}
        fixedDecimalScale={true}
      />
    );
  };

  return (
    <>
      <div>{amountFormatter()}</div>
      <> </>
    </>
  );
};
